import React, { Component } from 'react';
import { Container, Alert } from 'reactstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from '@store/actions';
import ProgressBox from '@components/ProgressBox/ProgressBox';

import Style from './Login.module.scss';

// Images
import Logo from '@assets/images/logo.png';

class Login extends Component {
  state = {
    email: '',
    password: '',
    rememberMe: true
  };

  updateForm = (event, name) => {
    this.setState({
      [name]: event.target.value
    });
  };

  submitHandler = event => {
    event.preventDefault();
    this.props.onAuth(
      this.state.email,
      this.state.password,
      this.state.rememberMe
    );
    return false;
  };

  onKeepLoggedIn = event => {
    this.setState({
      rememberMe: event.currentTarget.checked
    });
  };

  render = () => {
    const logoStyles = {
      width: '200px'
    }
    return (
      <Container fluid={true} className={'h-100 text-center'} style={{paddingTop: '5rem'}}>
        <form className={Style['form-signin']} onSubmit={this.submitHandler}>
          <div className={'position-relative p-2'}>
            {this.props.loading && (
              <ProgressBox
                text={'Submitting ...'}
                loader={'white-background'}
              />
            )}
            <img className="mb-4" src={Logo} alt="Logos" style={logoStyles}/>
            <h1 className="h3 mb-3 font-weight-normal">NXT Insurance Hub</h1>
            {this.props.error !== null && (
              <div>
                <Alert color={'danger'}>{this.props.error}</Alert>
              </div>
            )}
            <input
              className={'form-control mb-3'}
              name={'Email'}
              type={'text'}
              placeholder={'Email'}
              required={true}
              value={this.state.email}
              onChange={event => this.updateForm(event, 'email')}
            />

            <input
              className={'form-control'}
              name={'Password'}
              type={'password'}
              placeholder={'Password'}
              required={true}
              autoComplete={'off'}
              value={this.state.password}
              onChange={event => this.updateForm(event, 'password')}
            />
            <div className="checkbox mb-3 text-left pt-3">
              <label>
                <input
                  type={'checkbox'}
                  checked={this.state.rememberMe}
                  onChange={this.onKeepLoggedIn}
                />{' '}
                Keep Me Signed In
              </label>
            </div>
            <button className="btn btn-lg btn-primary btn-block" type="submit">
              Sign in
            </button>
            <hr />
            <Link to={'/forgot-password'} className={'color-white'}>
              Forgot Password?
            </Link>
          </div>
        </form>
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    error: state.auth.error,
    loading: state.auth.loading
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onAuth: (email, password, rememberMe) =>
      dispatch(actions.auth(email, password, rememberMe))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
